import { InputHTMLAttributes, LabelHTMLAttributes } from "react";
import "./index.scss";

export function MergeLabelAndInputMobile({ children, className = "" }) {
  return <div className={`px-8 flex flex-col w-full ${className}`}>{children}</div>;
}

export function LabelMobile({ className, ...rest }: LabelHTMLAttributes<HTMLLabelElement>) {
  return <label {...rest} className={`label-mobile ${className}`} />;
}

export function InputMobile({ className, ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...rest} className={`input-mobile ${className}`} />;
}
